import { reactive, computed } from 'vue'

const state = reactive({
  lang: localStorage.getItem('arqau_lang') || 'ru'
})

export function setLang(lang) {
  state.lang = lang
  localStorage.setItem('arqau_lang', lang)
}

export const currentLang = computed(() => state.lang)

const dict = {
  // ── Sidebar ──────────────────────────────────────────────────
  'Панель управления': {
    ru: 'Панель управления',
    kz: 'Басқару тақтасы'
  },
  'Опросники': {
    ru: 'Опросники',
    kz: 'Сауалнамалар'
  },
  'Психомониторинг': {
    ru: 'Психомониторинг',
    kz: 'Психомониторинг'
  },
  'Контент приложения': {
    ru: 'Контент приложения',
    kz: 'Қолданба мазмұны'
  },
  'Пользователи': {
    ru: 'Пользователи',
    kz: 'Қолданушылар'
  },
  'Режим прохождения': {
    ru: 'Режим прохождения',
    kz: 'Сауалнама толтыру режимі'
  },
  'Выйти': {
    ru: 'Выйти',
    kz: 'Шығу'
  },

  // ── Doctor workspace ─────────────────────────────────────────
  'Кабинет врача': { ru: 'Кабинет врача', kz: 'Дәрігер кабинеті' },
  'Прохождения': { ru: 'Прохождения', kz: 'Сауалнамалар' },
  'История': { ru: 'История', kz: 'Тарих' },
  'Развернуть меню': { ru: 'Развернуть меню', kz: 'Мәзірді жаю' },
  'Свернуть меню': { ru: 'Свернуть меню', kz: 'Мәзірді жию' },
  'Открыть меню': { ru: 'Открыть меню', kz: 'Мәзірді ашу' },
  'Выберите опросник, укажите отметку и начните прохождение.': { ru: 'Выберите опросник, укажите отметку и начните прохождение.', kz: 'Сауалнаманы таңдап, белгі енгізіңіз де, толтыруды бастаңыз.' },
  'Посмотреть историю': { ru: 'Посмотреть историю', kz: 'Тарихты көру' },
  'Найти опросник': { ru: 'Найти опросник', kz: 'Сауалнаманы іздеу' },
  'Язык опросника': { ru: 'Язык опросника', kz: 'Сауалнама тілі' },
  'Опросники не найдены': { ru: 'Опросники не найдены', kz: 'Сауалнамалар табылмады' },
  'Измените запрос или выберите другой язык.': { ru: 'Измените запрос или выберите другой язык.', kz: 'Іздеу сұрауын өзгертіңіз немесе басқа тілді таңдаңыз.' },
  'Опросник для оценки текущего состояния.': { ru: 'Опросник для оценки текущего состояния.', kz: 'Қазіргі жағдайды бағалауға арналған сауалнама.' },
  'Начать': { ru: 'Начать', kz: 'Бастау' },
  'пройдено': { ru: 'пройдено', kz: 'рет толтырылды' },
  'Не удалось загрузить опросники': { ru: 'Не удалось загрузить опросники', kz: 'Сауалнамалар жүктелмеді' },
  'Все заполненные вами опросники и сохранённые отметки.': { ru: 'Все заполненные вами опросники и сохранённые отметки.', kz: 'Сіз толтырған сауалнамалар мен сақталған белгілердің барлығы.' },
  'Новое прохождение': { ru: 'Новое прохождение', kz: 'Жаңа сауалнама' },
  'Поиск по названию или отметке': { ru: 'Поиск по названию или отметке', kz: 'Атауы не белгісі бойынша іздеу' },
  'Все опросники': { ru: 'Все опросники', kz: 'Барлық сауалнамалар' },
  'История пока пуста': { ru: 'История пока пуста', kz: 'Тарихта әзірге жазба жоқ' },
  'Завершённые опросники появятся в этом разделе.': { ru: 'Завершённые опросники появятся в этом разделе.', kz: 'Толтырылған сауалнамалар осы бөлімде көрсетіледі.' },
  'Опросник': { ru: 'Опросник', kz: 'Сауалнама' },
  'Отметка': { ru: 'Отметка', kz: 'Белгі' },
  'Результат': { ru: 'Результат', kz: 'Нәтиже' },
  'ID прохождения': { ru: 'ID прохождения', kz: 'Жазба ID-і' },
  'Без отметки': { ru: 'Без отметки', kz: 'Белгі жоқ' },
  'баллов': { ru: 'баллов', kz: 'балл' },
  'Завершён': { ru: 'Завершён', kz: 'Аяқталды' },
  'Показано': { ru: 'Показано', kz: 'Көрсетілгені' },
  'Не удалось загрузить историю': { ru: 'Не удалось загрузить историю', kz: 'Тарих жүктелмеді' },
  'К прохождениям': { ru: 'К прохождениям', kz: 'Сауалнамаларға' },
  'Опрос завершён': { ru: 'Опрос завершён', kz: 'Сауалнама аяқталды' },
  'Ответы и отметка сохранены в истории.': { ru: 'Ответы и отметка сохранены в истории.', kz: 'Жауаптар мен белгі тарихқа сақталды.' },
  'Посмотреть результат': { ru: 'Посмотреть результат', kz: 'Нәтижені көру' },
  'Прохождение опросника': { ru: 'Прохождение опросника', kz: 'Сауалнаманы толтыру' },
  'Свободное поле, по которому вы сможете найти это прохождение в истории.': { ru: 'Свободное поле, по которому вы сможете найти это прохождение в истории.', kz: 'Осы сауалнаманы тарихтан табуға көмектесетін еркін мәтін өрісі.' },
  'Пример отметки': { ru: 'Например: первичный приём, пациент А-104 или любой комментарий', kz: 'Мысалы: алғашқы қабылдау, A-104 пациенті немесе кез келген түсініктеме' },
  'Вернуться к истории': { ru: 'Вернуться к истории', kz: 'Тарихқа оралу' },
  'Результат прохождения': { ru: 'Результат прохождения', kz: 'Сауалнама нәтижесі' },
  'Итоговая оценка': { ru: 'Итоговая оценка', kz: 'Қорытынды баға' },
  'Ответы': { ru: 'Ответы', kz: 'Жауаптар' },
  'Результат не найден': { ru: 'Результат не найден', kz: 'Нәтиже табылмады' },
  'Не удалось загрузить результат': { ru: 'Не удалось загрузить результат', kz: 'Нәтиже жүктелмеді' },
  'Тревожность': { ru: 'Тревожность', kz: 'Мазасыздық' },
  'Общий показатель SDQ': { ru: 'Общий показатель SDQ', kz: 'SDQ жалпы көрсеткіші' },
  'Минимальный': { ru: 'Минимальный', kz: 'Төмен' },
  'Лёгкий': { ru: 'Лёгкий', kz: 'Жеңіл' },
  'Умеренный': { ru: 'Умеренный', kz: 'Орташа' },
  'Тяжёлый': { ru: 'Тяжёлый', kz: 'Ауыр' },
  'Крайне тяжёлый': { ru: 'Крайне тяжёлый', kz: 'Аса ауыр' },
  'Критический': { ru: 'Критический', kz: 'Критикалық' },
  'Результат рассчитан': { ru: 'Результат рассчитан', kz: 'Нәтиже есептелді' },

  // ── Directories ───────────────────────────────────────────────────
  'Справочники': { ru: 'Справочники', kz: 'Анықтамалықтар' },
  'Регионы': { ru: 'Регионы', kz: 'Өңірлер' },
  'Клиники': { ru: 'Клиники', kz: 'Клиникалар' },
  'Врачи': { ru: 'Врачи', kz: 'Дәрігерлер' },
  'Все регионы': { ru: 'Все регионы', kz: 'Барлық өңірлер' },
  'Все клиники': { ru: 'Все клиники', kz: 'Барлық клиникалар' },
  'Название (RU)': { ru: 'Название (RU)', kz: 'Атауы (RU)' },
  'Название (KZ)': { ru: 'Название (KZ)', kz: 'Атауы (KZ)' },
  'Клиника': { ru: 'Клиника', kz: 'Клиника' },
  'Регион': { ru: 'Регион', kz: 'Өңір' },
  'Действия': { ru: 'Действия', kz: 'Әрекеттер' },
  'Врач': { ru: 'Врач', kz: 'Дәрігер' },
  'Специализация': { ru: 'Специализация', kz: 'Мамандығы' },
  'Регион и клиника': { ru: 'Регион и клиника', kz: 'Өңір және клиника' },
  'Стаж': { ru: 'Стаж', kz: 'Өтілі' },
  'Без клиники': { ru: 'Без клиники', kz: 'Клиникасыз' },
  'лет': { ru: 'лет', kz: 'жыл' },
  'Добавить регион': { ru: 'Добавить регион', kz: 'Өңір қосу' },
  'Добавить клинику': { ru: 'Добавить клинику', kz: 'Клиника қосу' },
  'Добавить врача': { ru: 'Добавить врача', kz: 'Дәрігер қосу' },
  'Выберите регион': { ru: 'Выберите регион', kz: 'Өңірді таңдаңыз' },
  'Отчество': { ru: 'Отчество', kz: 'Әкесінің аты' },
  'Стаж (лет)': { ru: 'Стаж (лет)', kz: 'Өтілі (жыл)' },
  'Специализация (RU)': { ru: 'Специализация (RU)', kz: 'Мамандығы (RU)' },
  'Специализация (KZ)': { ru: 'Специализация (KZ)', kz: 'Мамандығы (KZ)' },
  'Телефон': { ru: 'Телефон', kz: 'Телефон' },
  'Активная запись': { ru: 'Активная запись', kz: 'Белсенді жазба' },
  'Неактивен': { ru: 'Неактивен', kz: 'Белсенді емес' },
  'Удалить': { ru: 'Удалить', kz: 'Жою' },
  'Удалить запись?': { ru: 'Удалить запись?', kz: 'Жазбаны жою керек пе?' },
  'Поиск по регионам...': { ru: 'Поиск по регионам...', kz: 'Өңірлер бойынша іздеу...' },
  'Поиск по клиникам...': { ru: 'Поиск по клиникам...', kz: 'Клиникалар бойынша іздеу...' },
  'Поиск по ФИО или специализации...': { ru: 'Поиск по ФИО или специализации...', kz: 'Аты-жөні немесе мамандығы бойынша іздеу...' },
  'Регионы не найдены': { ru: 'Регионы не найдены', kz: 'Өңірлер табылмады' },
  'Клиники не найдены': { ru: 'Клиники не найдены', kz: 'Клиникалар табылмады' },
  'Врачи не найдены': { ru: 'Врачи не найдены', kz: 'Дәрігерлер табылмады' },
  'Изменить регион': { ru: 'Изменить регион', kz: 'Өңірді өзгерту' },
  'Изменить клинику': { ru: 'Изменить клинику', kz: 'Клиниканы өзгерту' },
  'Сначала выберите регион': { ru: 'Сначала выберите регион', kz: 'Алдымен өңірді таңдаңыз' },
  'Код': { ru: 'Код', kz: 'Код' },
  'Район': { ru: 'Район', kz: 'Аудан' },
  'Районы': { ru: 'Районы', kz: 'Аудандар' },
  'Адрес': { ru: 'Адрес', kz: 'Мекенжай' },
  'Тип': { ru: 'Тип', kz: 'Түрі' },
  'Регион / район': { ru: 'Регион / район', kz: 'Өңір / аудан' },
  'Регион / клиника': { ru: 'Регион / клиника', kz: 'Өңір / клиника' },
  'БИН': { ru: 'БИН', kz: 'БСН' },
  'РПН / СУР': { ru: 'РПН / СУР', kz: 'РПН / СУР' },
  'Без района': { ru: 'Без района', kz: 'Аудансыз' },
  'Районы региона': { ru: 'Районы региона', kz: 'Өңір аудандары' },
  'Добавить район': { ru: 'Добавить район', kz: 'Аудан қосу' },
  'Изменить район': { ru: 'Изменить район', kz: 'Ауданды өзгерту' },
  'Загрузка районов...': { ru: 'Загрузка районов...', kz: 'Аудандар жүктелуде...' },
  'Районы не добавлены': { ru: 'Районы не добавлены', kz: 'Аудандар қосылмаған' },
  'Удалить район?': { ru: 'Удалить район?', kz: 'Ауданды жою керек пе?' },
  'Код региона': { ru: 'Код региона', kz: 'Өңір коды' },
  'Основные данные': { ru: 'Основные данные', kz: 'Негізгі деректер' },
  'Адрес (RU)': { ru: 'Адрес (RU)', kz: 'Мекенжайы (RU)' },
  'Адрес (KZ)': { ru: 'Адрес (KZ)', kz: 'Мекенжайы (KZ)' },
  'Идентификаторы и настройки': { ru: 'Идентификаторы и настройки', kz: 'Идентификаторлар және баптаулар' },
  'РПН ID': { ru: 'РПН ID', kz: 'РПН ID' },
  'СУР ID': { ru: 'СУР ID', kz: 'СУР ID' },
  'Запрет записи за N минут': { ru: 'Запрет записи за N минут', kz: 'Жазылуға N минут қалғанда тыйым салу' },
  'Тип клиники': { ru: 'Тип клиники', kz: 'Клиника түрі' },
  'Некоммерческая': { ru: 'Некоммерческая', kz: 'Коммерциялық емес' },
  'Коммерческая': { ru: 'Коммерческая', kz: 'Коммерциялық' },
  'Республиканский центр': { ru: 'Республиканский центр', kz: 'Республикалық орталық' },
  'Активная клиника': { ru: 'Активная клиника', kz: 'Белсенді клиника' },
  'Неактивна': { ru: 'Неактивна', kz: 'Белсенді емес' },
  'Требовать ЭЦП для заключения': { ru: 'Требовать ЭЦП для заключения', kz: 'Қорытындыға ЭЦҚ талап ету' },
  'Использовать новый видеосервис': { ru: 'Использовать новый видеосервис', kz: 'Жаңа бейнесервисті пайдалану' },
  'Редактировать врача': { ru: 'Редактировать врача', kz: 'Дәрігерді өзгерту' },
  'Личные данные': { ru: 'Личные данные', kz: 'Жеке деректер' },
  'Пол': { ru: 'Пол', kz: 'Жынысы' },
  'Выберите': { ru: 'Выберите', kz: 'Таңдаңыз' },
  'Мужской': { ru: 'Мужской', kz: 'Ер' },
  'Женский': { ru: 'Женский', kz: 'Әйел' },
  'ИИН': { ru: 'ИИН', kz: 'ЖСН' },
  '12 цифр': { ru: '12 цифр', kz: '12 сан' },
  'Дата рождения': { ru: 'Дата рождения', kz: 'Туған күні' },
  'Контактная информация': { ru: 'Контактная информация', kz: 'Байланыс ақпараты' },
  'Пароль учётной записи': { ru: 'Пароль учётной записи', kz: 'Тіркелгі құпия сөзі' },
  'Минимум 8 символов': { ru: 'Минимум 8 символов', kz: 'Кемінде 8 таңба' },
  'Введите пароль только если хотите его изменить.': { ru: 'Введите пароль только если хотите его изменить.', kz: 'Құпия сөзді өзгерткіңіз келсе ғана енгізіңіз.' },
  'Для входа врач будет использовать ИИН и этот пароль.': { ru: 'Для входа врач будет использовать ИИН и этот пароль.', kz: 'Жүйеге кіру үшін дәрігер ЖСН мен осы құпия сөзді пайдаланады.' },
  'Фотография профиля': { ru: 'Фотография профиля', kz: 'Профиль фотосуреті' },
  'Выбрать фото': { ru: 'Выбрать фото', kz: 'Фотосуретті таңдау' },
  'или': { ru: 'или', kz: 'немесе' },
  'Привязка к медицинскому учреждению': { ru: 'Привязка к медицинскому учреждению', kz: 'Медициналық ұйымға тіркеу' },
  'Основная специализация': { ru: 'Основная специализация', kz: 'Негізгі мамандық' },
  'Не выбрана': { ru: 'Не выбрана', kz: 'Таңдалмаған' },
  'Не удалось загрузить специализации': { ru: 'Не удалось загрузить специализации', kz: 'Мамандықтарды жүктеу мүмкін болмады' },
  'Не удалось загрузить районы и клиники': { ru: 'Не удалось загрузить районы и клиники', kz: 'Аудандар мен клиникаларды жүктеу мүмкін болмады' },
  'Не удалось сохранить врача': { ru: 'Не удалось сохранить врача', kz: 'Дәрігерді сақтау мүмкін болмады' },
  'Сначала укажите ИИН': { ru: 'Сначала укажите ИИН', kz: 'Алдымен ЖСН көрсетіңіз' },
  'Учётную запись можно создать после добавления ИИН при редактировании врача.': { ru: 'Учётную запись можно создать после добавления ИИН при редактировании врача.', kz: 'Дәрігерді өзгерту кезінде ЖСН қосқаннан кейін тіркелгі жасауға болады.' },
  'Недоступно при добавлении': { ru: 'Недоступно при добавлении', kz: 'Қосу кезінде қолжетімсіз' },
  'На странице:': { ru: 'На странице:', kz: 'Бетте:' },
  'Пагинация': { ru: 'Пагинация', kz: 'Беттер' },
  'Предыдущая страница': { ru: 'Предыдущая страница', kz: 'Алдыңғы бет' },
  'Следующая страница': { ru: 'Следующая страница', kz: 'Келесі бет' },

  // ── StaffSurveys ─────────────────────────────────────────────
  'Создание и управление опросами для пациентов': {
    ru: 'Создание и управление опросами для пациентов',
    kz: 'Науқастарға арналған сауалнамаларды жасау және басқару'
  },
  'Создать опрос': {
    ru: 'Создать опрос',
    kz: 'Сауалнама жасау'
  },
  'Всего опросов': {
    ru: 'Всего опросов',
    kz: 'Барлық сауалнама'
  },
  'Активных': {
    ru: 'Активных',
    kz: 'Белсенді'
  },
  'Всего ответов': {
    ru: 'Всего ответов',
    kz: 'Барлық жауап'
  },
  'Черновики': {
    ru: 'Черновики',
    kz: 'Жобалар'
  },
  'Поиск по названию...': {
    ru: 'Поиск по названию...',
    kz: 'Атауы бойынша іздеу...'
  },
  'Все статусы': {
    ru: 'Все статусы',
    kz: 'Барлық күй'
  },
  'Активные': {
    ru: 'Активные',
    kz: 'Белсенділер'
  },
  'Неактивные': {
    ru: 'Неактивные',
    kz: 'Белсенді емес'
  },
  'Все языки': {
    ru: 'Все языки',
    kz: 'Барлық тіл'
  },
  'Русский': {
    ru: 'Русский',
    kz: 'Орысша'
  },
  'Казахский': {
    ru: 'Казахский',
    kz: 'Қазақша'
  },
  'Обновить': {
    ru: 'Обновить',
    kz: 'Жаңарту'
  },
  'Загрузка опросов...': {
    ru: 'Загрузка опросов...',
    kz: 'Сауалнамалар жүктелуде...'
  },
  'Ошибка загрузки опросов. Проверьте подключение к серверу.': {
    ru: 'Ошибка загрузки опросов. Проверьте подключение к серверу.',
    kz: 'Сауалнамаларды жүктеу қатесі. Сервер байланысын тексеріңіз.'
  },
  'Повторить': {
    ru: 'Повторить',
    kz: 'Қайталау'
  },
  'Опросы не найдены': {
    ru: 'Опросы не найдены',
    kz: 'Сауалнамалар табылмады'
  },
  'Нет созданных опросов': {
    ru: 'Нет созданных опросов',
    kz: 'Жасалған сауалнама жоқ'
  },
  'Попробуйте изменить критерии поиска': {
    ru: 'Попробуйте изменить критерии поиска',
    kz: 'Іздеу параметрлерін өзгертіп көріңіз'
  },
  'Создайте первый опрос для сбора обратной связи': {
    ru: 'Создайте первый опрос для сбора обратной связи',
    kz: 'Пікір жинау үшін алғашқы сауалнаманы жасаңыз'
  },
  'Создать первый опрос': {
    ru: 'Создать первый опрос',
    kz: 'Алғашқы сауалнаманы жасау'
  },
  'Активен': {
    ru: 'Активен',
    kz: 'Белсенді'
  },
  'Черновик': {
    ru: 'Черновик',
    kz: 'Жоба'
  },
  'Анонимный': {
    ru: 'Анонимный',
    kz: 'Анонимді'
  },
  'вопросов': {
    ru: 'вопросов',
    kz: 'сұрақ'
  },
  'ответов': {
    ru: 'ответов',
    kz: 'жауап'
  },
  'Парная': {
    ru: 'Парная',
    kz: 'Жұптасқан'
  },
  'Деактивировать': {
    ru: 'Деактивировать',
    kz: 'Өшіру'
  },
  'Активировать': {
    ru: 'Активировать',
    kz: 'Қосу'
  },
  'Ошибка изменения статуса опроса': {
    ru: 'Ошибка изменения статуса опроса',
    kz: 'Сауалнама күйін өзгерту қатесі'
  },
  'Ошибка дублирования опроса': {
    ru: 'Ошибка дублирования опроса',
    kz: 'Сауалнаманы көшіру қатесі'
  },
  'Вы уверены, что хотите удалить этот опрос? Все ответы также будут удалены.': {
    ru: 'Вы уверены, что хотите удалить этот опрос? Все ответы также будут удалены.',
    kz: 'Бұл сауалнаманы жойғыңыз келетініне сенімдісіз бе? Барлық жауаптар да жойылады.'
  },
  'Ошибка удаления опроса': {
    ru: 'Ошибка удаления опроса',
    kz: 'Сауалнаманы жою қатесі'
  },

  // ── Login ─────────────────────────────────────────────────────
  'Вход в систему': {
    ru: 'Вход в систему',
    kz: 'Жүйеге кіру'
  },
  'Введите email или имя пользователя': {
    ru: 'Введите email или имя пользователя',
    kz: 'Email немесе пайдаланушы атыңызды енгізіңіз'
  },
  'Введите пароль': {
    ru: 'Введите пароль',
    kz: 'Құпиясөзді енгізіңіз'
  },
  'Показать пароль': {
    ru: 'Показать пароль',
    kz: 'Құпиясөзді көрсету'
  },
  'Войдите, чтобы управлять или проходить опросы': {
    ru: 'Войдите, чтобы управлять или проходить опросы',
    kz: 'Сауалнамаларды басқару немесе толтыру үшін кіріңіз'
  },
  'Логин или email': {
    ru: 'Логин или email',
    kz: 'Логин немесе email'
  },
  'Пароль': {
    ru: 'Пароль',
    kz: 'Құпия сөз'
  },
  'Запомнить меня': {
    ru: 'Запомнить меня',
    kz: 'Мені есте сақта'
  },
  'Вход...': {
    ru: 'Вход...',
    kz: 'Кіру...'
  },
  'Войти': {
    ru: 'Войти',
    kz: 'Кіру'
  },
  'Не удалось войти': {
    ru: 'Не удалось войти',
    kz: 'Кіру мүмкін болмады'
  },

  // ── AvailableSurveys ──────────────────────────────────────────
  'Конфиденциально и бережно': {
    ru: 'Конфиденциально и бережно',
    kz: 'Құпия және мұқият'
  },
  'ARQAU · Опросники': {
    ru: 'ARQAU · Опросники',
    kz: 'ARQAU · Сауалнамалар'
  },
  'Пройдите оценку своего состояния без регистрации': {
    ru: 'Пройдите оценку своего состояния без регистрации',
    kz: 'Тіркелмей-ақ өз жағдайыңызды бағалаңыз'
  },
  'Загрузка...': {
    ru: 'Загрузка...',
    kz: 'Жүктелуде...'
  },
  'Сейчас нет доступных опросов': {
    ru: 'Сейчас нет доступных опросов',
    kz: 'Қазір қолжетімді сауалнама жоқ'
  },
  'Повторяемый': {
    ru: 'Повторяемый',
    kz: 'Қайталамалы'
  },
  'Пройти': {
    ru: 'Пройти',
    kz: 'Толтыру'
  },
  'Не удалось загрузить опросы': {
    ru: 'Не удалось загрузить опросы',
    kz: 'Сауалнамаларды жүктеу мүмкін болмады'
  },

  // ── SurveyTake ────────────────────────────────────────────────
  '← К списку опросов': {
    ru: '← К списку опросов',
    kz: '← Сауалнамалар тізіміне'
  },
  'К списку опросов': {
    ru: 'К списку опросов',
    kz: 'Сауалнамалар тізіміне'
  },
  'Спасибо': {
    ru: 'Спасибо',
    kz: 'Рақмет'
  },
  'Ваши ответы успешно отправлены.': {
    ru: 'Ваши ответы успешно отправлены.',
    kz: 'Жауаптарыңыз сәтті жіберілді.'
  },
  'Вернуться к опросам': {
    ru: 'Вернуться к опросам',
    kz: 'Сауалнамаларға оралу'
  },
  'Выберите вариант': {
    ru: 'Выберите вариант',
    kz: 'Нұсқаны таңдаңыз'
  },
  'Минимум': {
    ru: 'Минимум',
    kz: 'Ең аз'
  },
  'Максимум': {
    ru: 'Максимум',
    kz: 'Ең көп'
  },
  'Отправка...': {
    ru: 'Отправка...',
    kz: 'Жіберілуде...'
  },
  'Отправить ответы': {
    ru: 'Отправить ответы',
    kz: 'Жауаптарды жіберу'
  },
  'Не удалось загрузить опрос': {
    ru: 'Не удалось загрузить опрос',
    kz: 'Сауалнаманы жүктеу мүмкін болмады'
  },
  'Не удалось отправить ответы': {
    ru: 'Не удалось отправить ответы',
    kz: 'Жауаптарды жіберу мүмкін болмады'
  },
  'Рекомендуемый раздел: Техники': {
    ru: 'Рекомендуемый раздел: Техники',
    kz: 'Ұсынылған бөлім: Техникалар'
  },
  'Рекомендуемый раздел: План безопасности': {
    ru: 'Рекомендуемый раздел: План безопасности',
    kz: 'Ұсынылған бөлім: Қауіпсіздік жоспары'
  },
  'Рекомендуемый раздел: Тревожная кнопка': {
    ru: 'Рекомендуемый раздел: Тревожная кнопка',
    kz: 'Ұсынылған бөлім: Қауіп төнгенде'
  },

  // ── Users ─────────────────────────────────────────────────────
  'Пользователи панели': {
    ru: 'Пользователи панели',
    kz: 'Жүйе қолданушылары'
  },
  'Добавить пользователя': {
    ru: 'Добавить пользователя',
    kz: 'Қолданушы қосу'
  },
  'ФИО, логин или email': {
    ru: 'ФИО, логин или email',
    kz: 'Аты-жөні, логин немесе email'
  },
  'Все статусы (users)': {
    ru: 'Все статусы',
    kz: 'Барлық күй'
  },
  'Заблокированные': {
    ru: 'Заблокированные',
    kz: 'Бұғатталғандар'
  },
  'Найти': {
    ru: 'Найти',
    kz: 'Іздеу'
  },
  'Пользователь': {
    ru: 'Пользователь',
    kz: 'Қолданушы'
  },
  'Роль': {
    ru: 'Роль',
    kz: 'Рөл'
  },
  'Статус': {
    ru: 'Статус',
    kz: 'Мәртебе'
  },
  'Действие': {
    ru: 'Действие',
    kz: 'Әрекет'
  },
  'Сотрудник': {
    ru: 'Сотрудник',
    kz: 'Қызметкер'
  },
  'Заблокирован': {
    ru: 'Заблокирован',
    kz: 'Бұғатталған'
  },
  'Активировать пользователя': {
    ru: 'Активировать пользователя',
    kz: 'Қолданушыны белсендіру'
  },
  'Изменить': {
    ru: 'Изменить',
    kz: 'Өзгерту'
  },
  'Пользователи не найдены': {
    ru: 'Пользователи не найдены',
    kz: 'Қолданушылар табылмады'
  },
  'Всего': {
    ru: 'Всего:',
    kz: 'Барлығы:'
  },
  'Назад': {
    ru: 'Назад',
    kz: 'Артқа'
  },
  'Далее': {
    ru: 'Далее',
    kz: 'Келесі'
  },
  'из': {
    ru: 'из',
    kz: '/'
  },
  'Изменить пользователя': {
    ru: 'Изменить пользователя',
    kz: 'Қолданушыны өзгерту'
  },
  'Добавить пользователя (заголовок)': {
    ru: 'Добавить пользователя',
    kz: 'Қолданушы қосу'
  },
  'Закрыть': {
    ru: 'Закрыть',
    kz: 'Жабу'
  },
  'Логин': {
    ru: 'Логин',
    kz: 'Логин'
  },
  'Имя': {
    ru: 'Имя',
    kz: 'Аты'
  },
  'Фамилия': {
    ru: 'Фамилия',
    kz: 'Тегі'
  },
  'Новый пароль': {
    ru: 'Новый пароль',
    kz: 'Жаңа құпия сөз'
  },
  'Оставьте пустым, чтобы не менять': {
    ru: 'Оставьте пустым, чтобы не менять',
    kz: 'Өзгертпеу үшін бос қалдырыңыз'
  },
  'Отмена': {
    ru: 'Отмена',
    kz: 'Бас тарту'
  },
  'Сохранение...': {
    ru: 'Сохранение...',
    kz: 'Сақталуда...'
  },
  'Сохранить': {
    ru: 'Сохранить',
    kz: 'Сақтау'
  },
  'Не удалось загрузить пользователей': {
    ru: 'Не удалось загрузить пользователей',
    kz: 'Қолданушыларды жүктеу мүмкін болмады'
  },
  'Не удалось сохранить изменения': {
    ru: 'Не удалось сохранить изменения',
    kz: 'Өзгерістерді сақтау мүмкін болмады'
  },

  // ── MobileContent ─────────────────────────────────────────────
  'Контент мобильного приложения': {
    ru: 'Контент мобильного приложения',
    kz: 'Мобильді қолданба мазмұны'
  },
  'ARQAU · конфиденциально и бережно': {
    ru: 'ARQAU · конфиденциально и бережно',
    kz: 'ARQAU · құпия және мұқият'
  },
  'Пространство для самопонимания и эмоционального благополучия': {
    ru: 'Пространство для самопонимания и эмоционального благополучия',
    kz: 'Өзін-өзі түсіну және эмоционалдық әл-ауқат кеңістігі.'
  },
  'Управляйте опросами, пользователями и материалами в единой системе': {
    ru: 'Управляйте опросами, пользователями и материалами в единой системе',
    kz: 'Сауалнамаларды, пайдаланушыларды және материалдарды біртұтас жүйе арқылы басқарыңыз.'
  },
  'Добавить': {
    ru: 'Добавить',
    kz: 'Қосу'
  },
  'Техники': {
    ru: 'Техники',
    kz: 'Техникалар'
  },
  'План безопасности': {
    ru: 'План безопасности',
    kz: 'Қауіпсіздік жоспары'
  },
  'Телефоны помощи': {
    ru: 'Телефоны помощи',
    kz: 'Көмек телефондары'
  },
  'Причины жить': {
    ru: 'Причины жить',
    kz: 'Өмір сүру себептері'
  },
  'Тексты приложения': {
    ru: 'Тексты приложения',
    kz: 'Қолданба мәтіндері'
  },
  'Рекомендации': {
    ru: 'Рекомендации',
    kz: 'Ұсыныстар'
  },
  'Ключ и текст': {
    ru: 'Ключ и текст',
    kz: 'Кілт және мәтін'
  },
  'Название': {
    ru: 'Название',
    kz: 'Атауы'
  },
  'Раздел': {
    ru: 'Раздел',
    kz: 'Бөлім'
  },
  'Порядок': {
    ru: 'Порядок',
    kz: 'Реті'
  },
  'Активно': {
    ru: 'Активно',
    kz: 'Белсенді'
  },
  'Скрыто': {
    ru: 'Скрыто',
    kz: 'Жасырын'
  },
  'Записей пока нет': {
    ru: 'Записей пока нет',
    kz: 'Жазба жоқ'
  },
  'Изменить (заголовок)': {
    ru: 'Изменить',
    kz: 'Өзгерту'
  },
  'Не удалось загрузить контент': {
    ru: 'Не удалось загрузить контент',
    kz: 'Мазмұнды жүктеу мүмкін болмады'
  },
  'Тревожная кнопка': {
    ru: 'Тревожная кнопка',
    kz: 'Қауіп төнгенде'
  },
  'Норма': {
    ru: 'Норма',
    kz: 'Қалыпты'
  },
  'Лёгкая': {
    ru: 'Лёгкая',
    kz: 'Жеңіл'
  },
  'Средняя': {
    ru: 'Средняя',
    kz: 'Орташа'
  },
  'Тяжёлая': {
    ru: 'Тяжёлая',
    kz: 'Ауыр'
  },
  'Крайне тяжёлая': {
    ru: 'Крайне тяжёлая',
    kz: 'Өте ауыр'
  },
  'Критическая': {
    ru: 'Критическая',
    kz: 'Күрделі'
  },

  'Не удалось загрузить данные': {
    ru: 'Не удалось загрузить данные',
    kz: 'Деректерді жүктеу мүмкін болмады'
  },
  'Тип риска': {
    ru: 'Тип риска',
    kz: 'Қауіп түрі'
  },
  'Сортировка': {
    ru: 'Сортировка',
    kz: 'Сұрыптау'
  },
  'Сначала критические': {
    ru: 'Сначала критические',
    kz: 'Алдымен күрделі'
  },
  'Выберите опросник для просмотра': {
    ru: 'Выберите опросник для просмотра результатов',
    kz: 'Нәтижелерді қарау үшін сауалнаманы таңдаңыз'
  },
  'Нет результатов для отображения': {
    ru: 'Нет результатов для отображения',
    kz: 'Көрсету үшін нәтиже жоқ'
  },
  'Депрессия': {
    ru: 'Депрессия',
    kz: 'Депрессия'
  },
  'Тревога': {
    ru: 'Тревога',
    kz: 'Үрей'
  },
  'Стресс': {
    ru: 'Стресс',
    kz: 'Стресс'
  },
  'Трудности': {
    ru: 'Трудности',
    kz: 'Қиындықтар'
  },
  'Трудн.': {
    ru: 'Трудн.',
    kz: 'Қиын.'
  },
  'Самоповреждение': {
    ru: 'Самоповреждение',
    kz: 'Өзіне-өзі зиян келтіру'
  },
  'Самопов.': {
    ru: 'Самопов.',
    kz: 'Зиян'
  },
  'Суицидальный риск': {
    ru: 'Суицидальный риск',
    kz: 'Суицид қаупі'
  },
  'Суицид': {
    ru: 'Суицид',
    kz: 'Суицид'
  },
  'Ответ': {
    ru: 'Ответ',
    kz: 'Жауап'
  },
  'последний': {
    ru: 'последний',
    kz: 'соңғы'
  },
  'Отклонения': {
    ru: 'Отклонения',
    kz: 'Ауытқулар'
  },
  'Нажмите для деталей': {
    ru: 'Нажмите для деталей',
    kz: 'Толығырақ қарау үшін басыңыз'
  },
  'Полные ответы на опрос': {
    ru: 'Полные ответы на опрос',
    kz: 'Сауалнамаға толық жауаптар'
  },
  'Дата': {
    ru: 'Дата',
    kz: 'Күні'
  },
  'Вопрос': {
    ru: 'Вопрос',
    kz: 'Сұрақ'
  },
  'Строка': {
    ru: 'Строка',
    kz: 'Жол'
  },
  'Ответы не найдены': {
    ru: 'Ответы не найдены для этого прохождения опроса.',
    kz: 'Бұл сауалнама бойынша жауаптар табылмады.'
  },
  'Не удалось загрузить детали ответа': {
    ru: 'Не удалось загрузить детали ответа.',
    kz: 'Жауап мәліметтерін жүктеу мүмкін болмады.'
  },
  'Нет ответа': {
    ru: 'Нет ответа',
    kz: 'Жауап жоқ'
  },

  // ── PsychologicalRiskDashboard ────────────────────────────────
  'Результаты опроса': {
    ru: 'Результаты опроса',
    kz: 'Сауалнама нәтижелері'
  },
  'Результаты опроса организации': {
    ru: 'Результаты опроса организации',
    kz: 'Ұйым сауалнамасының нәтижелері'
  },
  'Критический риск': {
    ru: 'Критический риск',
    kz: 'Критикалық қауіп'
  },
  'Группа риска': {
    ru: 'Группа риска',
    kz: 'Қауіп тобы'
  },
  'Всего (стат)': {
    ru: 'Всего',
    kz: 'Барлығы'
  },

  // ── Privacy Policy ───────────────────────────────────────────
  'Политика конфиденциальности': {
    ru: 'Политика конфиденциальности',
    kz: 'Құпиялылық саясаты'
  },
  'Вернуться ко входу': {
    ru: 'Вернуться ко входу',
    kz: 'Кіру бетіне оралу'
  },
  'Перейти ко входу': {
    ru: 'Перейти ко входу',
    kz: 'Кіру бетіне өту'
  },
  'Все права защищены': {
    ru: 'Все права защищены',
    kz: 'Барлық құқықтар қорғалған'
  },

  // ── Survey Interpretations ────────────────────────────────────
  'Результат оценки': {
    ru: 'Результат оценки',
    kz: 'Бағалау нәтижесі'
  },
  'Ваш результат': {
    ru: 'Ваш результат',
    kz: 'Сіздің нәтижеңіз'
  },
  'Интерпретация результатов': {
    ru: 'Интерпретация результатов',
    kz: 'Нәтижелерді түсіндіру'
  },
  'Официальная оценка': {
    ru: 'Официальная оценка',
    kz: 'Ресми бағалау'
  },
  'Официальная интерпретация': {
    ru: 'Официальная интерпретация',
    kz: 'Ресми интерпретация'
  },
  'Официальная интерпретация:': {
    ru: 'Официальная интерпретация:',
    kz: 'Ресми интерпретация:'
  },
  'Депрессивные проявления': {
    ru: 'Депрессивные проявления',
    kz: 'Депрессиялық көріністер'
  },
  'Симптомы тревоги': {
    ru: 'Симптомы тревоги',
    kz: 'Мазасыздық белгілері'
  },
  'Стрессовое состояние': {
    ru: 'Стрессовое состояние',
    kz: 'Күйзеліс жағдайы'
  },
  'Симптомы депрессии (PHQ-9)': {
    ru: 'Симптомы депрессии (PHQ-9)',
    kz: 'Депрессия белгілері (PHQ-9)'
  },
  'Симптомы тревоги (GAD-7)': {
    ru: 'Симптомы тревоги (GAD-7)',
    kz: 'Мазасыздық белгілері (GAD-7)'
  },
  'Депрессия (PHQ-9)': {
    ru: 'Депрессия (PHQ-9)',
    kz: 'Депрессия (PHQ-9)'
  },
  'Тревожность (GAD-7)': {
    ru: 'Тревожность (GAD-7)',
    kz: 'Мазасыздық (GAD-7)'
  }
}

export function t(key) {
  const entry = dict[key]
  if (!entry) return key
  return entry[state.lang] || entry['ru'] || key
}
